























import { Vue, Component } from 'vue-property-decorator'
import Table from '@/components/table/Table.vue'
import { TableResponse } from '@/components/table'
import {
  createConfig,
  downloadExcel
} from '@/service/enroll/chongmingStudentEnroll'
import { ChongmingStudent } from '@/models/enroll/chongmingStudent'
import { bak } from '@/api/enroll/chongmingStudent'
import { notify } from '@/utils/notification'


@Component({
  components: { Table }
})
export default class ChongmingStudentManage extends Vue {

  config = createConfig()
  data = [] as ChongmingStudent[]
  componentKey = 0
  handleDownloadCurrent() {
    downloadExcel(this.data)
  }

  handleDownloadAll() {
    downloadExcel()
  }
  async handleBakAll() {
    try {
      await bak()
      notify('备份成功！')
      this.componentKey += 1
    } catch (e) {
      notify('错误', e)
    }

  }

  handleRefresh({ rows }: TableResponse<ChongmingStudent>) {
    this.data = rows
  }
}
